import { Edit, SimpleForm, useNotify, useRecordContext, useRedirect } from 'react-admin';
import { Alert } from '@mui/material';
import { __t } from '../../i18n/t';
import { DevRequest } from '../../models/devRequest';
import { canEdit } from './actions';
import DevRequestFields, { toPayload } from './DevRequestForm';
import InternalGate from './InternalGate';

// Fora de pending sem retomada o backend recusa a edição; a tela nem oferece o formulário.
const Form = () => {
  const record = useRecordContext<DevRequest>();
  if (!record) { return null; }
  if (!canEdit(record.status, record.resumeReason)) {
    return <Alert severity="info">Este pedido não pode mais ser editado.</Alert>;
  }
  return (
    <SimpleForm>
      <DevRequestFields />
    </SimpleForm>
  );
};

const DevRequestEdit = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  return (
    <InternalGate>
      <Edit
        title="Editar pedido ao dev"
        mutationMode="pessimistic"
        transform={toPayload}
        mutationOptions={{
          onSuccess: (data: any) => {
            notify(__t('Rascunho salvo. Confira o texto e confirme o envio.'), { type: 'success' });
            redirect('show', 'dev-requests', data?.id, undefined, { sendNow: true });
          },
        }}
      >
        <Form />
      </Edit>
    </InternalGate>
  );
};

export default DevRequestEdit;
